import { render, staticRenderFns } from "./recurrences.vue?vue&type=template&id=0e74d70c&"
import script from "./recurrences.vue?vue&type=script&lang=ts&"
export * from "./recurrences.vue?vue&type=script&lang=ts&"
import style0 from "./recurrences.vue?vue&type=style&index=0&id=0e74d70c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports